
import { useTranslation } from "react-i18next";
import { Panel } from 'primereact/panel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';




export default function PontualidadePagamento({
  pontualidadePagamento
}: {
  pontualidadePagamento
  : any
}) {
  const { t } = useTranslation();

  return (
    <Panel header={t('pontualidadePagamento')}>
       
       {pontualidadePagamento.columns && (
        <DataTable emptyMessage="Nenhuma informação disponível" rowGroupMode="rowspan" groupRowsBy="doc" size="small" value={pontualidadePagamento.data} tableStyle={{ minWidth: '50rem' }}>
          {pontualidadePagamento.columns.map((col:any) => (
                      <Column key={col.field} field={col.field} header={col.header} />
                  ))}
        </DataTable>
       )}
       <p>{pontualidadePagamento.message}</p>
    </Panel>
  )
}
